import styled from 'styled-components'

export const Card = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Roboto', system-ui, sans-serif;
  color: #1a1a1a;
`

export const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  /* sobe a logo um pouco */
  margin-top: -20px;
  margin-bottom: 24px;

  img {
    display: block;
    max-height: 72px; /* era 32px → agora 48px (maior) */
    width: auto;
  }

  @media (max-width: 768px) {
    img {
      max-height: 56px;
    }
  }
`

export const BrandLogoMark = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;

  .dot {
    width: 8px;
    height: 12px;
    border-radius: 2px;
    background: #00c853;
  }

  .dot-green {
    background: #00c853;
  }

  .dot-yellow {
    background: #ffd600;
  }

  .dot-red {
    background: #ff5252;
  }
`

export const BrandText = styled.span`
  font-size: 1.75rem;
  line-height: 1.2;
  font-weight: 600;
  font-family: 'Roboto', system-ui, sans-serif;
  color: #1a4a5f; /* ajusta pro seu azul/petróleo do logo "ordeno" */
`

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
`

export const Subtitle = styled.p`
  font-size: 0.95rem;
  line-height: 1.4;
  color: #6b6b6b;
  text-align: center;
  margin: 0 0 24px 0;
`

export const GoogleButtonWrapper = styled.div`
  width: 60%;
  align-self: flex-end;
  margin-right: 20%;
  margin-bottom: 24px;
  
  display: flex;
  justify-content: center;

  button {
    width: 56px;
    height: 44px;
    border-radius: 8px;
    border: 1px solid #cfcfcf;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    /* sombra leve pra parecer botão flutuante */
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }

  button:hover {
    background-color: #f5f5f5;
  }
`

export const Divider = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`

export const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: #dcdcdc;
`

export const DividerText = styled.span`
  margin: 0 12px;
  font-size: 0.8rem;
  color: #6b6b6b;
`

export const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 16px;
`

export const Label = styled.label`
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 6px;
`

export const InputField = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 24px;
  border: 1px solid #cfcfcf;
  background-color: #efefef;
  padding: 0 14px;
  font-size: 0.9rem;
  color: #1a1a1a;

  &::placeholder {
    color: #9b9b9b;
  }
`

export const RememberRow = styled.div`
  width: 100%;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  row-gap: 12px;
`

export const RememberLeft = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1a1a1a;
  cursor: pointer;
  font-size: 0.9rem;
`

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

export const ForgotPass = styled.button`
  background: none;
  border: 0;
  font-size: 0.9rem;
  color: #0072ce;
  cursor: pointer;
  padding: 0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const SubmitButton = styled.button`
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 24px;
  background-color: #007dc9; /* azul botão */
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 16px;

  &:hover {
    filter: brightness(0.95);
  }
`

export const BottomText = styled.div`
  font-size: 0.9rem;
  color: #6b6b6b;
  text-align: center;

  .registerBtn {
    background: none;
    border: 0;
    color: #0072ce;
    padding-left: 6px;
    font-size: 0.9rem;
    cursor: pointer;
    text-decoration: none;
    font-weight: 500;
  }

  .registerBtn:hover {
    text-decoration: underline;
  }
`

export const ErrorMsg = styled.div`
  width: 100%;
  text-align: left;
  color: red;
  font-size: 0.8rem;
  margin-top: -8px;
  margin-bottom: 12px;
  font-weight: 500;
`
export const ErrContainer = styled.div`
  width: 100%;
  text-align: center;
  color: red;
  font-weight: 400;
  font-size: 0.85rem;
  margin-top: 8px;
`;
